var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Modal from "../../modules/Modal";
export default class OrderCancelModal {
    constructor() {
        var _a;
        this.container = document.querySelector('[data-order-cancel-modal]');
        if (!this.container) {
            return;
        }
        this.modal = new Modal('order-cancel');
        this.confirmButton = this.container.querySelector('[data-confirm-cancel-order]');
        this.ajaxApiUrl = window.localize_script.admin_ajax;
        this.texts = ((_a = this.container) === null || _a === void 0 ? void 0 : _a.dataset.texts) ? JSON.parse(this.container.dataset.texts) : {};
        this.init();
    }
    init() {
        document.addEventListener('click', (event) => {
            const target = event.target;
            if (target.hasAttribute('data-order-cancel-button')) {
                this.handleModalOpen(event);
            }
        });
        if (this.confirmButton) {
            this.confirmButton.addEventListener('click', (event) => {
                this.handleOrderCancel(event);
            });
        }
        const continueButton = this.container.querySelector('[data-continue-button]');
        if (continueButton) {
            continueButton.addEventListener('click', () => {
                this.modal.close();
                window.location.reload();
            });
        }
    }
    handleModalOpen(event) {
        event.preventDefault();
        this.resetModalState();
        const button = event.target;
        const orderId = button.dataset.orderId;
        if (orderId && this.confirmButton) {
            this.confirmButton.dataset.orderId = orderId;
            this.updateOrderName(button);
        }
    }
    updateOrderName(button) {
        const orderNamePlaceholder = this.container.querySelector('[data-order-name-placeholder]');
        const orderName = `${button.dataset.orderName}<br>(${button.dataset.orderCode})`;
        if (orderNamePlaceholder && orderName) {
            orderNamePlaceholder.innerHTML = orderName;
        }
    }
    resetModalState() {
        const cancellationContent = this.container.querySelector('[data-cancellation-content]');
        const successMessage = this.container.querySelector('[data-success-message]');
        const errorMessage = this.container.querySelector('[data-error-message]');
        const initialButtons = this.container.querySelector('[data-initial-buttons]');
        const successButtons = this.container.querySelector('[data-success-buttons]');
        cancellationContent === null || cancellationContent === void 0 ? void 0 : cancellationContent.classList.remove('hidden');
        successMessage === null || successMessage === void 0 ? void 0 : successMessage.classList.add('hidden');
        errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.classList.add('hidden');
        initialButtons === null || initialButtons === void 0 ? void 0 : initialButtons.classList.remove('hidden');
        successButtons === null || successButtons === void 0 ? void 0 : successButtons.classList.add('hidden');
    }
    handleOrderCancel(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            event.preventDefault();
            const button = event.target;
            const orderId = button.dataset.orderId;
            const nonce = button.dataset.nonce;
            if (!orderId) {
                return;
            }
            button.disabled = true;
            button.textContent = this.texts.canceling;
            try {
                const response = yield fetch(this.ajaxApiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        action: 'cancel_order',
                        order_id: orderId,
                        nonce: nonce !== null && nonce !== void 0 ? nonce : '',
                    })
                });
                const data = yield response.json();
                if (data.success) {
                    this.showSuccessState();
                }
                else {
                    this.showErrorState(((_a = data.data) === null || _a === void 0 ? void 0 : _a.message) || this.texts.error_occurred);
                }
            }
            catch (error) {
                console.error('Error canceling order:', error);
                this.showErrorState(this.texts.network_error);
            }
            finally {
                button.disabled = false;
                button.textContent = this.texts.cancel_order;
            }
        });
    }
    showSuccessState() {
        const cancellationContent = this.container.querySelector('[data-cancellation-content]');
        const successMessage = this.container.querySelector('[data-success-message]');
        const initialButtons = this.container.querySelector('[data-initial-buttons]');
        const successButtons = this.container.querySelector('[data-success-buttons]');
        cancellationContent === null || cancellationContent === void 0 ? void 0 : cancellationContent.classList.add('hidden');
        successMessage === null || successMessage === void 0 ? void 0 : successMessage.classList.remove('hidden');
        initialButtons === null || initialButtons === void 0 ? void 0 : initialButtons.classList.add('hidden');
        successButtons === null || successButtons === void 0 ? void 0 : successButtons.classList.remove('hidden');
    }
    showErrorState(message) {
        const errorMessage = this.container.querySelector('[data-error-message]');
        const errorText = this.container.querySelector('[data-error-text]');
        if (errorText) {
            errorText.textContent = message;
        }
        errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.classList.remove('hidden');
    }
}
